import {STAGE_DIRNAME, PORTAL_URL, TIMEOUT_TIME, BASE_PATH_API, BASE_PATH_API_DEV} from 'constants/general'
import axios from 'axios'


// Funcion Post Recovery Password
export  async function postPromoValidator(promotion){
   
    let apiURL = null
    const data = promotion

    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.promotions}/promotions/rules/validator`
    }else{
        apiURL = `${BASE_PATH_API}/promotions/rules/validator`
    }

    const config = {
        method: 'post',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}

export  async function getPromoValidator(promotion){
   
    let apiURL = null
    const data = promotion

    if(STAGE_DIRNAME === "dev"){
        apiURL = `${BASE_PATH_API_DEV.promotions}/promotions/rules/validator/?${promotion}`
    }else{
        apiURL = `${BASE_PATH_API}/promotions/rules/validator/?${promotion}`
    }

    const config = {
        method: 'get',
        url: apiURL,
        timeout: TIMEOUT_TIME,
        withCredentials: false,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };

    return await axios(config)
    .then(res => {
        const {
            headers, 
            status, 
            data
        } = res
        return {
            'headers': headers,
            'statusCode': status,
            'data': data,
            'error': ''
        }
    })
    .catch(error =>{
        //console.log(error)
        return {
            'headers': '',
            'statusCode': error.request.status,
            'data': error.request.response,
            'error': error.response.data.msg
        }
    })
}